import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'quotation';
var loaded = loadState(STORE_KEY) || {};

const defaultQuotationData = {
	vehicleValue: 0,
	period: '',
	start_date: '',
	totalPremium: 0,
	coverType: 'N/A',
};
const state = {
	quotationData: {
		vehicleValue:
			(loaded &&
				loaded.quotationData &&
				loaded.quotationData.vehicleValue) ||
			0,
		period:
			(loaded && loaded.quotationData && loaded.quotationData.period) ||
			'',
		start_date:
			(loaded &&
				loaded.quotationData &&
				loaded.quotationData.start_date) ||
			'',
		totalPremium:
			(loaded &&
				loaded.quotationData &&
				loaded.quotationData.totalPremium) ||
			0,
		coverType:
			(loaded &&
				loaded.quotationData &&
				loaded.quotationData.coverType) ||
			'N/A',
	},
	quotationResults: (loaded && loaded.quotationResults) || null,
	selectedQuotationReview: (loaded && loaded.selectedQuotationReview) || null,

	calculatedQuotation: loaded && loaded.calculatedQuotation,
	systemQuotationRef: loaded && loaded.systemQuotationRef,
	paymentResult: loaded && loaded.paymentResult,
	invoiceSystemRef: loaded && loaded.invoiceSystemRef,
};

const mutations = {
	SET_QUOTATION_DATA(state, quotationData) {
		state.quotationData = {
			...state.quotationData,
			...quotationData,
		};
		saveState(STORE_KEY, state);
	},
	SET_QUOTATION_RESULTS(state, quotation) {
		state.quotationResults = quotation;
		saveState(STORE_KEY, state);
	},
	SET_SELECTED_REVIEW(state, quotation) {
		state.selectedQuotationReview = quotation;
		saveState(STORE_KEY, state);
	},
	SET_CALCULATED_QUOTATION(state, data) {
		state.calculatedQuotation = data;
		saveState(STORE_KEY, state);
	},
	SET_SYSTEM_QUOTATION_REF(state, ref) {
		state.systemQuotationRef = ref;
		saveState(STORE_KEY, state);
	},
	SET_PAYMENT_RESULT(state, data) {
		state.paymentResult = data;
		saveState(STORE_KEY, state);
	},
	SET_INVOICE_REF(state, data) {
		state.invoiceSystemRef = data;
		saveState(STORE_KEY, state);
	},
	RESET_QUOTATION_MODULE(state) {
		state.quotationData = { ...defaultQuotationData };
		state.quotationResults = null;
		state.selectedQuotationReview = null;
		state.calculatedQuotation = null;
		state.systemQuotationRef = null;
		state.paymentResult = null;
		state.invoiceSystemRef = null;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setQuotationData({ commit }, quotationData) {
		commit('SET_QUOTATION_DATA', quotationData);
	},
	setQuotationResults({ commit }, quotation) {
		commit('SET_QUOTATION_RESULTS', quotation);
	},
	setSelectedQuotationReview({ commit }, quotation) {
		commit('SET_SELECTED_REVIEW', quotation);
	},
	setCalculatedQuotation({ commit }, data) {
		commit('SET_CALCULATED_QUOTATION', data);
	},
	setSystemQuotationRef({ commit }, ref) {
		commit('SET_SYSTEM_QUOTATION_REF', ref);
	},
	setPaymentResult({ commit }, data) {
		commit('SET_PAYMENT_RESULT', data);
	},
	setInvoiceRef({ commit }, data) {
		commit('SET_INVOICE_REF', data);
	},
	resetQuotationModule({ commit }) {
		commit('RESET_QUOTATION_MODULE');
	},
};

const getters = {
	selectQuotationData: (state) => state.quotationData,
	selectQuotationResults: (state) => state.quotationResults,
	selectedQuotationReview: (state) => state.selectedQuotationReview,
	selectCalculatedQuote: (state) => state.calculatedQuotation,
	selectSystemQuotation: (state) => state.systemQuotationRef,
	selectPaymentResult: (state) => state.paymentResult,
	selectInvoiceRef: (state) => state.invoiceSystemRef,
};
export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
